export const PERSON_CD_ATTENDEE_MA = 'tdoc_admin_ma';
export const PERSON_CD_ATTENDEE_RN = 'tdoc_admin_rn';
export const PERSON_CD_PROVIDER = 'tdoc_provider';
export const PERSON_CD_MEMBER = 'tdoc_member';
